"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let ContractStatusTransition = class ContractStatusTransition extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    getCurrentOptions(...args) {
        switch (args[0]) {
            case 'approved':
                return {
                    title: this.$fn.pgettext("Contract", "Approve"),
                    date: this.$fn.pgettext("Contract", "Approval date"),
                    dname: 'approval_date',
                    displayDate: true
                };
            case 'signed':
                return {
                    title: this.$fn.pgettext("Contract", "Sign"),
                    date: this.$fn.pgettext("Contract", "Signature date"),
                    dname: 'signature_date',
                    displayDate: true
                };
            case 'rescinded':
                return {
                    title: this.$fn.pgettext("Contract", "Rescind"),
                    date: this.$fn.pgettext("Contract", "Rescission date"),
                    dname: 'rescission_date',
                    displayDate: true
                };
            case 'active':
                return {
                    title: this.$fn.pgettext("Contract", "Activate"),
                    date: this.$fn.pgettext("Contract", "Valid from"),
                    dname: 'valid_from',
                    displayDate: true
                };
            case 'terminated':
                return {
                    title: this.$fn.pgettext("Contract", "Terminate"),
                    date: this.$fn.pgettext("Contract", "Termination date"),
                    effective_date: this.$fn.pgettext("Contract", "Termination effective date"),
                    dname: 'termination_date',
                    displayDate: true
                };
            case 'ended':
                return {
                    title: this.$fn.pgettext("Contract", "End"),
                    date: this.$fn.pgettext("Contract", "Ending date"),
                    dname: 'end_date',
                    displayDate: true
                };
            case 'archived':
                return {
                    title: this.$fn.pgettext("Contract", "Archive"),
                    date: this.$fn.pgettext("Contract", "Archive date"),
                    dname: 'archive_date',
                    displayDate: true
                };
            case 'unarchive':
                return {
                    title: this.$fn.pgettext("Contract", "Unarchive"),
                    displayDate: false,
                    notesRequired: true,
                    notesHelpText: this.$fn.pgettext('Contract', 'The reason for unarchiving must be justified.')
                };
        }
    }
    defaultData(...args) {
        const [status, contract] = args;
        switch (status) {
            case 'active': {
                return { date: contract.lifecycle.valid_from || this.$fn.today() };
            }
            case 'unarchive': {
                return { notes: null };
            }
            case 'terminated':
            case 'ended':
            case 'archived': {
                return { date: contract.lifecycle.valid_to || this.$fn.today() };
            }
        }
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    status;
    onStatus(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("status");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    options;
    async $$load_options() {
        return this.getCurrentOptions(this.status);
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    item;
    async $$load_item() {
        return _.extend({
            id: this.contract.id,
            rev: this.contract.revision_number,
            status: this.status,
            date: this.$fn.today(),
            effective_date: null,
            notes: null,
            $etag: this.contract.etag
        }, this.defaultData(this.status, this.contract));
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['options', 'formId', 'labelAlign', 'item', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                options: null,
                formId: null,
                labelAlign: "right",
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: ([this.contract.contract_number, this.options.title]),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_9036_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_closeModal_9042_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1040167445267876_request_9040_getActionArgs($event) {
        return {
            operation: "update_contract_status",
            data: _.set(this.item, this.options.dname, this.item.date),
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_9036 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_9036_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_9035 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_9036,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_9035],
        });
        const act_2248226175642056_closeComponent_9038 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_9037 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_9038,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_9037],
        });
        const act_1040167445267876_closeModal_9042 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_9042_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_9041 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_9042,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_request_9040 = new core_1.actions.RequestAction({
            actionArgs: this.act_1040167445267876_request_9040_getActionArgs,
            displayName: "submit",
            events: [evh_1040167445267876_success_9041],
        });
        const evh_1040167445267876_submit_9039 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_request_9040,
            event: "submit",
            displayName: "submit",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_9039],
        });
        const act_1419464017721962_closeComponent_9044 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_9043 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeComponent_9044,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_9043],
        });
        return {
            act_7315092382398562_closeModal_9036,
            evh_7315092382398562_close_9035,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_9038,
            evh_2248226175642056_close_9037,
            evh_2248226175642056_close,
            act_1040167445267876_closeModal_9042,
            evh_1040167445267876_success_9041,
            act_1040167445267876_request_9040,
            evh_1040167445267876_submit_9039,
            evh_1040167445267876_submit,
            act_1419464017721962_closeComponent_9044,
            evh_1419464017721962_clickPreventStop_9043,
            evh_1419464017721962_clickPreventStop,
            submit: act_1040167445267876_request_9040,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], ContractStatusTransition.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractStatusTransition.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], ContractStatusTransition.prototype, "status", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('status'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractStatusTransition.prototype, "onStatus", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], ContractStatusTransition.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractStatusTransition.prototype, "onSize", null);
ContractStatusTransition = __decorate([
    (0, vue_property_decorator_1.Component)()
], ContractStatusTransition);
exports.default = ContractStatusTransition;
vue_property_decorator_1.Vue.component("ContractStatusTransition", ContractStatusTransition);
